module.exports = __webpack_public_path__ + "static/poly-36-10f5367a6c31aad3388aad8f21fccd7b.png";